import {
  ApartmentOutlined,
  ApiOutlined,
  AudioOutlined,
  BorderOutlined,
  FundOutlined,
  GiftOutlined,
  HistoryOutlined,
  LineChartOutlined,
  PictureOutlined,
  PieChartOutlined,
  PlayCircleOutlined,
  ProfileOutlined,
  RobotOutlined,
  SoundOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import React from 'react';

export default {
  path: '/model-inference',
  code: 'ModelInference',
  name: '模型广场',
  component: './ModelInference/layout',
  routes: [
    {
      path: '/model-inference',
      hideInMenu: true,
      component: './MenuRedirect',
    },
    {
      path: '/model-inference/intro',
      hideInMenu: true,
      component: './ModelInference/ProductIntro',
    },
    {
      path: '/model-inference/activation',
      hideInMenu: true,
      component: './ModelInference/Activation',
    },
    {
      path: '/model-inference/model-dashboard',
      code: 'ModelInference-ModelDashboard',
      name: '模型看板',
      icon: <LineChartOutlined />,
      component: './ModelInference/ModelDashboard',
    },
    {
      path: '/model-inference/model-dashboard/detail/:inferenceModelId',
      code: 'ModelInference-ModelDashboard-Detail-Button',
      name: '模型详情',
      hideInMenu: true,
      component: './ModelInference/ModelDashboard/Detail',
    },
    {
      path: '/model-inference/package',
      code: 'ModelInference-Package',
      name: '购买套餐',
      icon: <GiftOutlined />,
      component: './ModelInference/Package',
    },
    {
      path: '/model-inference/subscription',
      code: 'ModelInference-Subscription',
      name: '我的套餐',
      icon: <ProfileOutlined />,
      component: './ModelInference/Subscription',
    },
    {
      path: '/model-inference/subscription/detail/:id',
      code: 'ModelInference-Subscription-Detail-Button',
      name: '套餐详情',
      hideInMenu: true,
      component: './ModelInference/Subscription/Detail',
    },
    {
      path: '/model-inference/api-key-management',
      code: 'ModelInference-ApiKeyManagement',
      name: 'API-Key 管理',
      icon: <ApiOutlined />,
      component: './ModelInference/ApiKeyManagement',
    },
    {
      path: '/model-inference/model-experience',
      code: 'ModelInference-ModelExperience',
      name: '模型体验',
      icon: <PlayCircleOutlined />,
      component: './ModelInference/ModelExperience/layout',
      routes: [
        {
          path: '/model-inference/model-experience',
          hideInMenu: true,
          component: './MenuRedirect',
        },
        {
          path: '/model-inference/model-experience/llm',
          code: 'ModelInference-ModelExperience-LLM',
          name: '大语言模型',
          icon: <RobotOutlined />,
          component: './ModelInference/ModelExperience/LLM',
        },
        {
          path: '/model-inference/model-experience/embedding',
          code: 'ModelInference-ModelExperience-Embedding',
          name: '嵌入模型',
          icon: <BorderOutlined />,
          component: './ModelInference/ModelExperience/Embedding',
        },
        {
          path: '/model-inference/model-experience/rerank',
          code: 'ModelInference-ModelExperience-Rerank',
          name: '重排模型',
          icon: <ApartmentOutlined />,
          component: './ModelInference/ModelExperience/Rerank',
        },
        {
          path: '/model-inference/model-experience/speech-synthesis',
          code: 'ModelInference-ModelExperience-SpeechSynthesis',
          name: '语音合成',
          icon: <SoundOutlined />,
          component: './ModelInference/ModelExperience/SpeechSynthesis',
        },
        {
          path: '/model-inference/model-experience/speech-recognition',
          code: 'ModelInference-ModelExperience-SpeechRecognition',
          name: '语音识别',
          icon: <AudioOutlined />,
          component: './ModelInference/ModelExperience/SpeechRecognition',
        },
        {
          path: '/model-inference/model-experience/text-to-image',
          code: 'ModelInference-ModelExperience-TextToImage',
          name: '文生图',
          icon: <PictureOutlined />,
          component: './ModelInference/ModelExperience/TextToImage',
        },
        {
          path: '/model-inference/model-experience/vision-language',
          code: 'ModelInference-ModelExperience-VisionLanguage',
          name: '视觉语言模型',
          icon: <RobotOutlined />,
          component: './ModelInference/ModelExperience/VisionLanguage',
        },
        // 这期不做
        // {
        //   path: '/model-inference/model-experience/tool-calling',
        //   code: 'ModelInference-ModelExperience-ToolCalling',
        //   name: '工具调用',
        //   icon: <ToolOutlined />,
        //   component: './ModelInference/ModelExperience/ToolCalling',
        // },
      ],
    },
    {
      path: '/model-inference/token-package',
      code: 'ModelInference-TokenPackage',
      name: 'Token 额度',
      icon: <WalletOutlined />,
      routes: [
        {
          path: '/model-inference/token-package',
          hideInMenu: true,
          component: './MenuRedirect',
        },
        {
          path: '/model-inference/token-package/overview',
          code: 'ModelInference-TokenPackage-Overview',
          name: 'Token 额度总览',
          icon: <PieChartOutlined />,
          component: './ModelInference/TokenPackage/Overview',
        },
        {
          path: '/model-inference/token-package/history',
          code: 'ModelInference-TokenPackage-History',
          name: '额度记录',
          icon: <HistoryOutlined />,
          component: './ModelInference/TokenPackage/History',
        },
      ],
    },
    {
      path: '/model-inference/token-metering',
      code: 'ModelInference-TokenMetering',
      name: '使用记录',
      icon: <FundOutlined />,
      component: './ModelInference/TokenMetering',
    },
    {
      path: '/model-inference/usage-statistics',
      code: 'ModelInference-UsageStatistics',
      name: '用量统计',
      icon: <FundOutlined />,
      component: './ModelInference/UsageStatistics',
    },
  ],
};
